// extracted by mini-css-extract-plugin
export default {"release":"ReleaseInfo_release__odKph"};